import { render } from "./HeroiconsOutlineHashtag.vue?vue&type=template&id=42c5e37c"
const script = {}

import exportComponent from "/home/nginx/domains/panel.vip-mod.net/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineHashtag.vue"]])

export default __exports__